import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from 'react-bootstrap';
import ImportDxf from './ImportDxf';
import TranslateCanvas from './TranslateCanvas';

function ControlsBottom({
  saveCanvas,
  cleanCanvas,
  exportJSON,
  exportDXF,
  disabled,
}) {
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (disabled) return null;

  return (
    <div className="w-100 d-flex justify-content-end">
      <div className="d-flex justify-content-end">
        <ButtonGroup size="sm mt-1">
          <Button
            type="button"
            onClick={(event) => {
              event.preventDefault();
              saveCanvas();
            }}
            variant="outline-primary"
          >
            Save
          </Button>
          <Button
            onClick={cleanCanvas}
            variant="outline-primary"
          >
            Clear Canvas
          </Button>
          {isDevelopment ? (
            <Button
              onClick={exportJSON}
              variant="outline-primary"
            >
              Export JSON
            </Button>
          ) : null}
          <Button
            onClick={exportDXF}
            variant="outline-primary"
          >
            Export DXF
          </Button>
          {isDevelopment ? <ImportDxf /> : null}
          {isDevelopment ? <TranslateCanvas /> : null}
        </ButtonGroup>
      </div>
    </div>
  );
}

ControlsBottom.defaultProps = {
  disabled: true,
  exportJSON: null,
  exportDXF: null,
};

ControlsBottom.propTypes = {
  cleanCanvas: PropTypes.func.isRequired,
  saveCanvas: PropTypes.func.isRequired,
  exportJSON: PropTypes.func,
  exportDXF: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ControlsBottom;
